// extracted by mini-css-extract-plugin
export default {"container":"ProtectedRoute_container__ot69s"};